import './lancamentos.css';
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import TopoIcone from "./TopoIcone";
import { Truck, Warehouse, ScanBarcode, CornerDownLeft, SearchCheck, Save, X as IconX, Trash2, ChevronLeft } from "lucide-react";
import axios from "axios";
import QuaggaScanner from "./QuaggaScanner";
import tratarCodigoLido from "./FUNCTratarCodigoLido";


function Saida() {
  const navigate = useNavigate();
  const location = useLocation();
  const usuarioLogado = location.state?.usuario || localStorage.getItem("nomeUsuario") || "USUÁRIO DESCONHECIDO";

  const [mensagemScanner, setMensagemScanner] = useState(false);

  const [data, setData] = useState(new Date().toISOString().slice(0, 10));
  const [buscaCliente, setBuscaCliente] = useState("");
  const [clientesEncontrados, setClientesEncontrados] = useState([]);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [codigoCliente, setCodigoCliente] = useState("");
  const [carrinhoCodigo, setCarrinhoCodigo] = useState("");
  const [carrinhos, setCarrinhos] = useState([]);
  const buscaTimeout = useRef(null);
  const [foco, setFoco] = useState("");
  const [alertaCarrinho, setAlertaCarrinho] = useState(false);
  const [scannerAberto, setScannerAberto] = useState(false);
  const [alertaSaida, setAlertaSaida] = useState(false);
  const [rotaDestino, setRotaDestino] = useState("");
  const [alertaCarrinhoDesconhecido, setAlertaCarrinhoDesconhecido] = useState(false);
  const [mensagemSucesso, setMensagemSucesso] = useState(false);
  const formatarData = (valor) => {
    if (!valor) return '';
    const [ano, mes, dia] = valor.split('-');
    return `${dia}/${mes}/${ano}`;
  };

  // PARTE SCANNER
  const podeLerRef = useRef(true); // começa podendo ler
  const quaggaRef = useRef(null);  // onde vamos guardar o Quagga para controle
  const [codigoLidoDesconhecido, setCodigoLidoDesconhecido] = useState("");





  useEffect(() => {
    if (!clienteSelecionado && buscaCliente.length >= 3 && isNaN(buscaCliente)) {
      clearTimeout(buscaTimeout.current);
      buscaTimeout.current = setTimeout(async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_API}/clientes?busca=${buscaCliente}`);
          const termo = buscaCliente.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").trim();
          const filtrados = res.data.filter(c => c.nome_fantasia?.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").trim().includes(termo));
          setClientesEncontrados(filtrados);
        } catch (err) {
          console.error("Erro ao buscar cliente", err);
        }
      }, 400);
    } else {
      setClientesEncontrados([]);
    }
  }, [buscaCliente, clienteSelecionado]);

  const buscarPorCodigo = async () => {
    if (!codigoCliente.trim()) return;
    try {
      const res = await axios.get(`${process.env.REACT_APP_API}/clientes?busca=${codigoCliente}`);
      const cliente = res.data.find(c => String(c.idt).trim() === String(codigoCliente).trim());
      cliente ? preencherCliente(cliente) : limparCliente();
    } catch (err) {
      console.error("Erro ao buscar cliente por código", err);
    }
  };

  const preencherCliente = (cliente) => {
    setClienteSelecionado(cliente);
    setCodigoCliente(String(cliente.idt));
    setBuscaCliente(cliente.nome_fantasia);
    setClientesEncontrados([]);
  };

  const limparCliente = () => {
    setClienteSelecionado(null);
    setBuscaCliente("");
    setCodigoCliente("");
  };

  const limparFormulario = () => {
    setData(new Date().toISOString().slice(0, 10));
    setBuscaCliente("");
    setClientesEncontrados([]);
    setClienteSelecionado(null);
    setCodigoCliente("");
    setCarrinhoCodigo("");
    setCarrinhos([]);
  };

  const adicionarCarrinho = async () => {
    const corrigido = carrinhoCodigo
  .normalize("NFD")
  .replace(/\p{Diacritic}/gu, "")
  .trim()
  .toUpperCase()
  .replace(/^CAR0+(\d+)$/, "CAR$1")
  .replace(/^B0+(\d+)$/, "B$1");
  console.log("🔍 Código digitado:", carrinhoCodigo);
console.log("✅ Código padronizado:", corrigido);


    if (!corrigido) {
      console.log("Carrinho vazio.");
      return;
    }

    if (carrinhos.find(c => c.codigo === corrigido)) {
      console.log("Carrinho duplicado.");
      setAlertaCarrinho(true);
      return;
    }

    try {
      const valida = await axios.get(`${process.env.REACT_APP_API}/verificar-carrinho?codigo=${corrigido}`);


      if (!valida.data.valido) {

        podeLerRef.current = false;               // bloqueia leitura

        setAlertaCarrinhoDesconhecido(true);     // mostra o alerta (deixa o scanner aberto)

        return;
      }



      const resposta = await axios.get(`${process.env.REACT_APP_API}/tempo-posse?codigo=${corrigido}`);
      const tempoPosse = resposta.data.tempo_posse ?? null;


      setCarrinhos([...carrinhos, { codigo: corrigido, tempo_posse: tempoPosse }]);

      setCarrinhoCodigo("");

    } catch (error) {
      console.error("Erro ao adicionar carrinho:", error);
    }
  };

  const removerCarrinho = (index) => {
    const novosCarrinhos = carrinhos.filter((_, i) => i !== index);
    setCarrinhos(novosCarrinhos);
  };

  const confirmarTrocaDeTela = (rota) => {
    if (carrinhos.length > 0) {
      setRotaDestino(rota);
      setAlertaSaida(true);
    } else {
      navigate(rota);
    }
  };

  const salvarSaida = async () => {
    try {
      // ✅ Pega o token da sessão atual (sessionStorage)
      const token = sessionStorage.getItem("token");

      const res = await axios.post(
        `${process.env.REACT_APP_API}/salvar-saida`,
        {
          data,
          codigoCliente,
          carrinhos,
          usuario: usuarioLogado
        },
        {
          headers: {
            Authorization: `Bearer ${token}` // ✅ Envia o token no cabeçalho
          }
        }
      );

      if (res.data.sucesso) {
        setMensagemSucesso(true);
        setTimeout(() => {
          setMensagemSucesso(false);
          limparFormulario();
        }, 2500);
      } else {
        alert("Erro ao salvar saída.");
      }
    } catch (err) {
      console.error("❌ Erro na gravação:", err);
      alert("Erro ao salvar saída.");
    }
  };

  const ClearIcon = ({ onClick }) => (
    <span
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      style={{
        position: "absolute",
        top: "8px",                  // 👈 sobe o botão
        right: "10px",
        transform: "none",           // 👈 remove centralização
        cursor: "pointer",
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        backgroundColor: "#f5f5f5",
        transition: "background 0.2s ease-in-out"
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ddd")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#f5f5f5")}
    >
      <IconX size={14} color="#666" />
    </span>
  );


  return (
    <div className="lancamento-container">
      {mensagemSucesso && (
        <div style={{
          position: 'fixed',
          top: '1rem',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#e6f9ec',
          color: '#10693e',
          padding: '0.75rem 1.25rem',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontWeight: 400,
          fontSize: '0.95rem',
          whiteSpace: 'nowrap'
        }}>
          <span style={{ fontSize: '1.25rem' }}>✅</span>
          Saída registrada com sucesso!
        </div>
      )}

      <div className="lancamento-dark-header">
        <TopoIcone icone={<Truck size={20} color="#00664F" />} />

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start', // 👈 garante alinhamento à esquerda
            width: '100%',                // 👈 ocupa toda a largura disponível
            gap: '0.5rem',
            padding: '0 1rem',
            height: '40px'
          }}
        >

          <div
            onClick={() => confirmarTrocaDeTela("/menu")}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          >


            <ChevronLeft size={24} color="white" strokeWidth={2} />
          </div>
          <span style={{ color: 'white', fontSize: '1.1rem', fontWeight: 'bold' }}>
            Saídas
          </span>
        </div>
      </div>


      <div className="lancamento-content">
        <div className="lancamento-ficha">
          <div style={{ width: "100%", overflow: "hidden", marginBottom: "0rem" }}>
            <div style={{ width: "100%", maxWidth: "100%", display: "flex" }}>
              <div style={{ position: "relative", width: "100%" }}>
                <label className="lancamento-label">Data</label>
                <input
                  type="text"
                  className="lancamento-input"
                  value={formatarData(data)}
                  readOnly
                  onClick={() => document.getElementById("inputDataReal").showPicker?.()} // dispara o calendário nativo
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    color: "#000",
                    backgroundColor: "#f0faf7",
                    cursor: "pointer"
                  }}
                />
                <input
                  id="inputDataReal"
                  type="date"
                  value={data}
                  onChange={(e) => setData(e.target.value)}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    opacity: 0,
                    cursor: "pointer"
                  }}
                />
              </div>


            </div>
          </div>



          <div style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem", alignItems: "flex-end" }}>
            <div style={{ flex: "0 0 70px", position: "relative" }}>

              <label className="lancamento-label">Destino</label>
              <input
                type="text"
                className="lancamento-input"
                value={codigoCliente}
                onFocus={() => setFoco("codigo")}
                onBlur={(e) => { setFoco(""); buscarPorCodigo(); }}
                onChange={(e) => setCodigoCliente(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    buscarPorCodigo();
                  }
                }}

              />
            </div>
            <div style={{ flex: 1, position: "relative" }}>
              <label className="lancamento-label" style={{ visibility: "hidden" }}>.</label>
              <div style={{ position: "relative", width: "100%" }}>
                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    type="text"
                    className="lancamento-input"
                    autoComplete="off"
                    placeholder="Digite o nome do cliente"
                    value={buscaCliente}
                    onFocus={() => setFoco("busca")}
                    onBlur={() => setFoco("")}
                    onChange={(e) => {
                      setBuscaCliente(e.target.value);
                      setClienteSelecionado(null);
                      setCodigoCliente("");
                    }}
                    style={{
                      paddingRight: "36px",  // espaço pro botão X
                      paddingLeft: "9px",
                      height: "36px",
                      boxSizing: "border-box"
                    }}
                  />

                  {/* Mostra o ClearIcon apenas se tiver texto */}
                  {buscaCliente && (
                    <ClearIcon onClick={() => {
                      setBuscaCliente("");
                      setClienteSelecionado(null);
                      setCodigoCliente("");
                    }} />
                  )}
                </div>


                {foco === "busca" && buscaCliente && (
                  <span
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setBuscaCliente("");
                      setCodigoCliente("");
                      setClienteSelecionado(null);
                    }}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor: "transparent",
                      transition: "background 0.2s ease-in-out",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#eee")}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                  >
                    <IconX size={14} color="#888" />
                  </span>
                )}

              </div>


              {buscaCliente.length >= 3 && clientesEncontrados.length > 0 && (
                <ul className="lancamento-autocomplete-list">
                  {clientesEncontrados.map((c) => (
                    <li key={c.idt} onClick={() => preencherCliente(c)}>{c.nome_fantasia}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <div className="lancamento-carrinho-wrapper">
            <label className="lancamento-label">Adicionar Carrinhos</label>
            <div className="lancamento-add-carrinho" style={{ position: "relative", marginBottom: "0rem" }}>
              <div style={{ position: "relative", width: "100%" }}>
                <input
                  type="text"
                  value={carrinhoCodigo}
                  onFocus={() => setFoco("carrinho")}
                  onBlur={() => setFoco("")}
                  onChange={(e) => setCarrinhoCodigo(e.target.value)}
                  onKeyDown={async (e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      await adicionarCarrinho();
                    }
                  }}
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck="false"
                  inputMode="text"
                  translate="no"
                  className="lancamento-input"
                  style={{ paddingRight: "36px" }}
                />

                {foco === "carrinho" && carrinhoCodigo && (
                  <span
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setCarrinhoCodigo("");
                    }}
                    style={{
                      position: "absolute",
                      right: "6px",
                      top: "43%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor: "transparent",
                      transition: "background 0.2s ease-in-out",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#eee")}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                  >
                    <IconX size={14} color="#888" />
                  </span>
                )}
              </div>


              <button onClick={async () => await adicionarCarrinho()} className="lancamento-add-button">+</button>

              {/* PARTE SCANNER */}
              <button

                onClick={() => {
                  podeLerRef.current = true;
                  setScannerAberto(true);
                }}
                className="lancamento-add-button"
                style={{
                  marginLeft: "0rem",
                  width: "45px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0
                }}
              >
                <ScanBarcode size={20} color="white" />
              </button>




            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginTop: '0.10rem', marginBottom: '0.25rem' }}>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#ccc' }}></div>
            <span style={{ padding: '0 0.75rem', fontWeight: 'bold', fontSize: '0.95rem', color: '#333' }}>Lançados</span>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#ccc' }}></div>
          </div>

          <div style={{
            border: '1px solid #ccc',
            borderRadius: '8px',
            padding: '0.5rem',
            marginBottom: '1rem',
            backgroundColor: '#fff',
            boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
            maxHeight: '270px',
            overflowY: 'auto'
          }}>
            {carrinhos.length === 0 ? (
              <div style={{ fontSize: '0.85rem', color: '#777', textAlign: 'center' }}>
                Nenhum carrinho lançado.
              </div>
            ) : (
              <table style={{ width: '100%', fontSize: '0.9rem', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'left', borderBottom: '1px solid #ccc', paddingBottom: '0.4rem' }}>Código</th>
                    <th
                      style={{
                        textAlign: 'center',
                        borderBottom: '1px solid #ccc',
                        padding: '0.4rem 0.5rem',
                        width: '70px'
                      }}
                      translate="no"
                    >
                      Posse
                    </th>
                    <th style={{ width: '30px' }}></th>
                  </tr>
                </thead>
                <tbody>
                  {Object.values(
                    carrinhos
                      .slice()
                      .reverse()
                      .reduce((acc, item) => {
                        acc[item.codigo] = item; // mantém o último com esse código
                        return acc;
                      }, {})
                  ).map((item, i) => {

                    const tempoPosseNumerico = Number(item.tempo_posse);
const isAlerta = tempoPosseNumerico > 20;

const isProprio =
  (item.tempo_posse === "" || item.tempo_posse === null) &&
  String(item.propriedade).trim().toUpperCase() === "PROPRIA";

return (
  <tr
    key={i}
    style={{
      backgroundColor: isAlerta
        ? "#ffe5e5" // Vermelho claro
        : isProprio
        ? "#eaffea" // Verde claro
        : "transparent"
    }}
  >

                        <td style={{ padding: '0.5rem 0', borderBottom: '1px solid #eee' }}>{item.codigo}</td>
                        <td
                          style={{
                            textAlign: 'center',
                            verticalAlign: 'middle',
                            padding: '0.5rem 0.5rem',
                            borderBottom: '1px solid #eee',
                            fontWeight: '500',
                            color: '#333'
                          }}
                          translate="no"
                        >
                          {item.tempo_posse ?? '-'}
                        </td>
                        <td style={{ paddingLeft: '0.5rem', borderBottom: '1px solid #eee' }}>
                          <Trash2
                            size={14}
                            color="#b30000"
                            style={{ cursor: 'pointer', opacity: 0.7 }}
                            onClick={() => removerCarrinho(carrinhos.length - 1 - i)}
                          />
                        </td>
                      </tr>
                    );
                  })}

                </tbody>
              </table>

            )}
          </div>

          <div className="lancamento-btn-group">
            <button className="lancamento-btn-cancelar-icon" onClick={limparFormulario} title="Cancelar">
              <IconX size={24} />
            </button>
            <div style={{ flex: 1, margin: "0 0.5rem" }}>
              <label className="lancamento-label" style={{ textAlign: "center", display: "block" }}>
                Quantidade
              </label>
              <input
                type="text"
                className="lancamento-input"
                value={carrinhos.length}
                readOnly
                style={{ textAlign: "center", height: "50px", fontSize: "2rem" }}
              />
            </div>
            <button
              className="lancamento-btn-salvar-icon"
              disabled={!clienteSelecionado || carrinhos.length === 0}
              title="Salvar"
              onClick={salvarSaida}
            >
              <Save size={24} />
            </button>

          </div>
        </div>
      </div>


      <div className="lancamento-footer-group">
        <div className="lancamento-shortcuts">
          <div className="lancamento-shortcut active" onClick={() => confirmarTrocaDeTela("/saida")}> <Truck size={20} color="#DB0B0E" /><span>Saída</span></div>
          <div className="lancamento-shortcut" onClick={() => confirmarTrocaDeTela("/estoque")}> <Warehouse size={20} color="#00996D" /><span>Estoque</span></div>
          <div className="lancamento-shortcut" onClick={() => confirmarTrocaDeTela("/devolucao")}> <CornerDownLeft size={20} color="#00996D" /><span>Devolução</span></div>
          <div className="lancamento-shortcut" onClick={() => confirmarTrocaDeTela("/decisao")}> <SearchCheck size={20} color="#00996D" /><span>Decidir</span></div>
        </div>
      </div>



      {alertaCarrinho && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.4)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '2rem',
            borderRadius: '12px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            textAlign: 'center',
            maxWidth: '300px',
            width: '80%'
          }}>
            <div style={{ marginBottom: '1rem' }}>
              <div style={{
                fontWeight: 'bold',
                color: '#b30000',
                fontSize: '1.1rem',
                marginBottom: '0.5rem'
              }}>
                ATENÇÃO
              </div>
              <div style={{
                fontSize: '1rem',
                color: '#333'
              }}>
                Carrinho já lançado!
              </div>
            </div>
            <button
              translate="no"
              autoComplete="off"
              autoCorrect="off"
              spellCheck="false"
              onClick={() => {
                setAlertaCarrinho(false);  // <- isso que fecha o alerta
                setCarrinhoCodigo("");     // <- isso limpa o campo, opcional
              }}
              style={{
                padding: '0.3rem 0.8rem',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: '#00996D',
                color: 'white',
                cursor: 'pointer',
                fontSize: '0.85rem'
              }}
            >
              OK
            </button>

          </div>
        </div>
      )}

      {alertaSaida && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.4)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}>
          <div style={{ backgroundColor: '#fff', padding: '2rem', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.3)', textAlign: 'center', maxWidth: '320px', width: '85%' }}>
            <div style={{ marginBottom: '1.5rem' }}>
              <div style={{ fontWeight: 'bold', color: '#b30000', fontSize: '1.1rem', marginBottom: '0.5rem' }}>
                ATENÇÃO
              </div>
              <div style={{ fontSize: '1rem', color: '#333' }}>
                Você tem um lançamento em andamento. Deseja sair mesmo assim?
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
              <button onClick={() => navigate(rotaDestino)} style={{ padding: '0.5rem 1rem', backgroundColor: '#ef4444', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}>
                SIM
              </button>
              <button onClick={() => setAlertaSaida(false)} style={{ padding: '0.5rem 1rem', backgroundColor: '#00996D', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}>
                NÃO
              </button>
            </div>
          </div>
        </div>
      )}




      {/* INICIO PARTE SCANNER */}
      {scannerAberto && (
        <QuaggaScanner
          ref={quaggaRef}
          podeLerRef={podeLerRef}
          onDetected={(codigo) => tratarCodigoLido(codigo, {
            carrinhos,
            setCarrinhos,
            setAlertaCarrinho,
            setAlertaCarrinhoDesconhecido,
            setCodigoLidoDesconhecido,
            setMensagemScanner,
            podeLerRef
          })}
          onClose={() => setScannerAberto(false)}
        />
      )}
      {/* FIM PARTE SCANNER */}



      {alertaCarrinho && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.4)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '2rem',
            borderRadius: '12px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            textAlign: 'center',
            maxWidth: '300px',
            width: '80%'
          }}>
            <div style={{ marginBottom: '1rem' }}>
              <div style={{
                fontWeight: 'bold',
                color: '#b30000',
                fontSize: '1.1rem',
                marginBottom: '0.5rem'
              }}>
                ATENÇÃO
              </div>
              <div style={{
                fontSize: '1rem',
                color: '#333'
              }}>
                Carrinho já lançado!
              </div>
            </div>
            <button
              translate="no"
              autoComplete="off"
              autoCorrect="off"
              spellCheck="false"
              onClick={() => {
                setAlertaCarrinho(false);  // <- isso que fecha o alerta
                setCarrinhoCodigo("");     // <- isso limpa o campo, opcional
              }}
              style={{
                padding: '0.3rem 0.8rem',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: '#EF4444',
                color: 'white',
                cursor: 'pointer',
                fontSize: '0.85rem'
              }}
            >
              OK
            </button>

          </div>
        </div>
      )}






      {alertaCarrinhoDesconhecido && (
        <div translate="no" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.4)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '2rem',
            borderRadius: '12px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            textAlign: 'center',
            maxWidth: '300px',
            width: '80%'
          }}>
            <div style={{ marginBottom: '1rem' }}>
              <div style={{
                fontWeight: 'bold',
                color: '#b30000',
                fontSize: '1.1rem',
                marginBottom: '0.5rem'
              }}>
                ATENÇÃO
              </div>
              <div style={{
                fontSize: '1rem',
                color: '#333'
              }}>
            <span>
  <strong>{codigoLidoDesconhecido}</strong>, Carrinho não reconhecido.
</span>
              </div>
            </div>
            <button

              // PARTE SCANNER
              onClick={() => {
                setAlertaCarrinhoDesconhecido(false);
              }}
              style={{
                padding: '0.3rem 0.8rem',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: '#EF4444',
                color: 'white',
                cursor: 'pointer',
                fontSize: '0.85rem'
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {mensagemScanner && (
        <div style={{
          position: 'fixed',
          top: '1rem',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#e6f9ec',
          color: '#10693e',
          padding: '0.75rem 1.25rem',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontWeight: 400,
          fontSize: '0.95rem',
          whiteSpace: 'nowrap'
        }}>
          <span style={{ fontSize: '1.25rem' }}>✅</span>
          Carrinho incluído com sucesso!
        </div>
      )}





    </div>

  );
}

export default Saida;